<template>
  <div v-if="load === 'success'" class="page">
    <Header class="page__header" />
    <gl-notification
      v-if="notification.type"
      :notification="notification"
      class="page__notification"
      @close="handleNotificationClose"
    />
    <router-view class="page__main" />
  </div>
  <gl-loader v-else is-centered />
</template>

<script>
import Header from '@/components/Header/index'
import { notification } from '@/store'
import GlNotification from '@gl/GlNotification'
import GlLoader from '@gl/GlLoader'
import { getBlockInfo } from '@/services/api'

export default {
  components: { GlNotification, Header, GlLoader },
  data() {
    return {
      load: 'loading',
      notification,
    }
  },
  async created() {
    await getBlockInfo()
    this.load = 'success'
  },
  mounted() {
    window.addEventListener('online', this.handleNetworkChange)
    window.addEventListener('offline', this.handleNetworkChange)
  },
  beforeUnmount() {
    window.removeEventListener('online', this.handleNetworkChange)
    window.removeEventListener('offline', this.handleNetworkChange)
  },
  methods: {
    handleNotificationClose() {
      notification.message = ''
      notification.type = ''
    },
    handleNetworkChange() {
      if (!navigator) return
      if (navigator.onLine) {
        document.body.classList.remove('offline')
      } else {
        document.body.classList.add('offline')
      }
    },
  },
}
</script>

<style lang="scss">
@import '~styles/main';

.page {
  $this: &;

  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 100vh;
  min-width: 320px;
  width: 100%;

  &__header {
    position: sticky;
    top: 0;
  }

  &__main {
    flex: 1 0 auto;
    overflow: hidden;
    width: 100%;
  }

  &__notification {
    left: 0;
    position: fixed;
    right: 0;
    top: var(--header-height);
    z-index: 10;
  }
}
</style>
